
export default {
    functional: true,

    render: function render(h, _ref) {
        var slots = _ref.slots;

        var _slots = slots();
        return h(
            "v-layout",
            {
                attrs: { row: true, "align-center": true },
                "class": "pb-3 table-tool-box" },
            [h(
                "v-flex",
                {
                    attrs: { xs4: true }
                },
                [_slots.left]
            ), h("v-spacer"), h("div", [h(
                "v-layout",
                {
                    attrs: { "justify-end": true }
                },
                [_slots.right]
            )])]
        );
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/table-tool-box.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/table-tool-box.vue
// module chunks = 34